import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { get, map } from 'lodash';
import useStyles from 'isomorphic-style-loader/useStyles';
import Account from 'modules/Account';
import App from 'modules/App';
import FormGroup from 'components/Form/FormGroup';
import { useIsGlucoseLevelUnitTypesRequired, usePatientProfileForm } from '../hooks';
import styles from './GlucoseLevelUnitTypes.pcss';
const GlucoseLevelUnitTypes = ()=>{
    useStyles(styles);
    const { formValues, setFormValue } = usePatientProfileForm();
    const selectedUnit = get(formValues, 'values.glucoseLevelUnitTypes', null);
    const shouldDisplay = useIsGlucoseLevelUnitTypesRequired();
    const renderButton = (unit)=>{
        const isSelected = selectedUnit === unit;
        return /*#__PURE__*/ _jsx("div", {
            className: cn(styles.glucoseLevelUnitTypes__unit, {
                [styles['glucoseLevelUnitTypes__unit--selected']]: isSelected
            }),
            "aria-hidden": "true",
            onClick: ()=>setFormValue({
                    id: 'glucoseLevelUnitTypes',
                    value: unit
                }),
            children: App.constants.UNITS_SYMBOLS[unit]
        }, unit);
    };
    if (!shouldDisplay) return null;
    return /*#__PURE__*/ _jsx(FormGroup, {
        id: "glucoseLevelUnitTypes",
        labelMessage: Account.messages.labels.bloodSugarUnits,
        formValues: formValues,
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.glucoseLevelUnitTypes,
            children: map(Object.keys(App.constants.BLOOD_GLUCOSE_CONCENTRATION_UNITS), renderButton)
        })
    });
};
export default GlucoseLevelUnitTypes;
